import { Box, Button, Card, Typography } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ReactQuill from 'react-quill';
import { post, Token } from '../../../Script/Session';
function ElementBeschlussbuch({ item, edit, del, update }) {
    const [readOnly, setreadonly] = useState(true);
    const [content, setcontent] = useState(item.message);
    const toolbarModules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link', 'image'],
            ['clean']
        ]
    }

    // Custom formats for ReactQuill
    const formats = [
        'header', 'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'link', 'image'
    ];
    const modulesWithEnter = {
        ...toolbarModules,
        keyboard: {
            bindings: {
                handleEnter: {
                    key: 13,
                    handler: function (range, context) {
                        const quill = this.quill;
                        // insert a line break inside current block
                        quill.insertText(range.index, '\n', 'user');
                        quill.setSelection(range.index + 1, 0);
                    }
                }
            }
        }
    };

    function d() {
        let body = {};
        body.token = Token.get();
        body.action = "delete";
        body.stamp = item.stamp;
        let response = post(body, "/beschlussbuch");
        if (response == "OK") {
            alert("Gelöscht!");
            window.location.reload();
        }
    }
    function save() {
        let body = {};
        body.token = Token.get();
        body.action = "edit";
        body.stamp = item.stamp;
        body.newmessage = content;
        let response = post(body, "/beschlussbuch");
        if (response == "OK") {
            alert("Bearbeitet");
            window.location.reload();
        }
        setreadonly(true);
    }
    return (

        <Card sx={{ mt: 2 }}>
            <Box sx={{ flexDirection: "row", display: "flex" }}>
                <AccountCircleOutlinedIcon sx={{ color: "gray", fontSize: "2.5rem", mt: "2px" }} />
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography sx={{ ml: 1 }} level="body-md">{item.name}</Typography>
                    <Typography sx={{ ml: 1 }} level="body-xs">{item.time}</Typography>
                </Box>
            </Box>
            <ReactQuill
                defaultValue={content}
                readOnly={readOnly}
                onChange={(e) => setcontent(e)}
                modules={readOnly ? { toolbar: false } : modulesWithEnter}
                formats={formats}
                preserveWhitespace={!readOnly}
            />


            <Box sx={{ flexDirection: "row", display: "flex", gap: 2 }}>
                {
                    del && (
                        <>
                            <Button color='danger' onClick={() => d()}>Löschen</Button>

                        </>
                    )
                }
                {
                    del && (
                        readOnly ? (
                            <><Button color="primary" onClick={() => setreadonly(false)}>Bearbeiten</Button></>
                        ) : (
                            <><Button color="primary" onClick={() => save()}>Speichern</Button></>
                        )
                    )
                }

            </Box>


        </Card>
    )
}

export default ElementBeschlussbuch
